import { heroEquipment } from "../HeroEquipment";

export const marienburg = {
  heroes: {
    Kapitan: {
      id: 0,
      startingEquipment: ["Sztylet", "Rapier"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Czarownik: {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Guślarstwo", "Mag (Kolegia Magii)"],
      exp: 12,
      skills: [2, 4, 5],
    },
    "Kapłan Mananna": {
      id: 2,
      startingEquipment: ["Sztylet", "Trójząb"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Kapłan,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Czarostwo","Duchowny (modlitwy do Mananna)","Modlitwa","Pogarda","Rozproszenie magii (2)"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    Bosman: {
      id: 3,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Podoficer"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Mat: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 15,
      number: 2,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Przyboczny"],
      exp: 0,
      skills: [0, 1, 4, 5],
    },
    Marynarz: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 99,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Drużyna obsługi", "Drużyna wsparcia"],
    },
    Harpunnik: {
      id: 6,
      startingEquipment: ["Sztylet", "Kusza"],
      cost: 30,
      number: 7,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Drużyna ciężkich broni (harpun)","Ranger","Zwiadowca"],
    },
    "Drużyna ciężkich broni": {
      id: 7,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 60,
      number: 2,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Ciężcy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Ranger", "Zwiadowca"],
    },
    "Żołnierz okrętowy": {
      id: 8,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 35,
      number: 5,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 4, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Szermierz"],
    },
    Przepatrywacz: {
      id: 9,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Włócznia",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Kawalerzysta", "Lekka jazda", "Ranger", "Zwiadowca"],
    },
    Bukanier: {
      id: 10,
      startingEquipment: ["Pistolet"],
      cost: 55,
      number: 5,
      equipmentList: heroEquipment["Piechota Morska z Marienburga"].Bukanier,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rajtar",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wodny",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Zaprzęg: {
      id: 11,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 600,
  minModels: 3,
  maxModels: 15,
  name: "Piechota Morska z Marienburga",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Zamożność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Czarownica",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Latarnik",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ordynans",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
